import { ReactNode } from 'react';
import { Form, FormikProps, FormikProvider } from 'formik';
import { Notification } from '@/components/Notification/Notification';

type FormikFormPropsType = {
  value: FormikProps<unknown>;
  children?: ReactNode;
  error?: string;
};

export const FormikForm = ({ error, value, children }: FormikFormPropsType) => {
  return (
    <>
      {error && (
        <Notification variant='error' marginBottom='16px'>
          {error}
        </Notification>
      )}
      <FormikProvider value={value}>
        <Form>{children}</Form>
      </FormikProvider>
    </>
  );
};
